import React, {useContext, useState, useEffect} from 'react'
import { QuestionContext } from '../../../../Context'
import { PickResultsCon } from './styles'

export const QuestionGroupStatus: React.FC = () => {
  const { questions } = useContext(QuestionContext)!

    const [actual, setActual] = useState<number>(0)
    const [total, setTotal] = useState<number>(0)

    useEffect(() => {
      if (questions.length > 0) {
        setTotal(questions.length)
  
        //Hasn't started
        const answered = questions.filter(q => q.userAnswerCode !== null)
        setActual(answered.length)
      }
    }, [questions])

  return (
    <PickResultsCon uiTheme='light'>
      <div className="title">Answered:</div>
      <div className="actual">{actual}</div>
      <div className="total">{`/${total}`}</div>
    </PickResultsCon>
  )
}
